import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Idropdown, IHome, Ipremiumtranscations } from '../sidenav/helper';
import { Router } from '@angular/router';
import { HomeService } from '../services/homeservice';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { DynamicTabsService } from '../dynamic-tabs.service';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from '../dialogs/delete-dialog/delete-dialog.component';

import { RefreshDialogComponent } from '../dialogs/refresh-dialog/refresh-dialog.component';
import { RenewPolicyComponent } from '../dialogs/renew-policy/renew-policy.component';
import { IfStmt } from '@angular/compiler';
import { BodyComponent } from '../body/body.component';
import { NotificationService } from '../services/notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { MatSort } from '@angular/material/sort'
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],

})
export class MainComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort,{static:true})sort!:MatSort;
  @Output() openDetailTab = new EventEmitter();
  @Input() id: number = 0;//194745;
  @Input() label: string = '';
  insured!: Idropdown[];
  polTy!: Idropdown[];
  polS!: Idropdown[];
  Con!: Idropdown[];
  premiumtransaction!: Ipremiumtranscations[]; //changing object name
  policy: IHome = new IHome();
  updateData: IHome = new IHome();
  response: IHome = new IHome();
  headerTitle: string | undefined;
  searchTerm: string = '';
  filteredData: Ipremiumtranscations[] = [];
  sortingColumn: string = '';
  sortOrder: 'asc' | 'desc' = 'asc';
  isSearching: boolean = false;
  isLoading: boolean = false;
  currentPage: number = 0;
  dataSource!: MatTableDataSource<Ipremiumtranscations>;
  totalItems: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 45;
  pageSizeOptions: number[] = [45, 90, 135];
  isHidePageSize: boolean = true;
  showFirstLastButtons = true;
  data: any[] = [];
  columnsToDisplay: string[] = [
    'name',
    'memberPolicyNumber',
    'transactionDate',
    'transactionType',
    'insuredValueChange',
    'premiumChange',
    'commands'

  ]

  constructor(

    public dynamicTabService: DynamicTabsService,
    private dialog: MatDialog,
    private cdRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private service: HomeService,
    private body: BodyComponent,
    private router: Router, private datePipe: DatePipe, private notificationService: NotificationService,
    private _snackBar: MatSnackBar) {
    this.dataSource = new MatTableDataSource<Ipremiumtranscations>([]);
  }
  ngOnInit(): void {
    // console.log('Inside ngOnInit')
    if (this.id > 0 && this.dynamicTabService && this.dynamicTabService.selectedTabData.type == 'policy' && this.dynamicTabService.selectedTabData.label == this.label) {
      this.getAccData();
      this.getDropPolTy();
      this.getDropPolS();
      this.getDropCon();
      this.getMasterPoliciesPremium(this.id); //194745
      this.getMasterPolicy(this.id);
    }

    //save
    this.dynamicTabService.saveObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'policy')
        this.updatePolicy();
    })

    //delete
    this.dynamicTabService.deleteObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'policy')
        this.deleteMasterPolicy();
    })

    //refresh
    this.dynamicTabService.refreshObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'policy')
        this.refresh();
    })
    //renew
    this.dynamicTabService.renewObv.subscribe(value => {
      if (value && this.dynamicTabService.selectedTabData && this.dynamicTabService.selectedTabData.label == this.label && this.dynamicTabService.selectedTabData.type == 'policy')
        this.renewPolicy();
    })

    //closeTab
    this.dynamicTabService.closeObv.subscribe(value => {
      if (value && this.dynamicTabService.closableTab && this.dynamicTabService.closableTab.type == 'policy' && sessionStorage.getItem("closeBtn") == "true")
        this.closeTab();
    })
    // this.loadTableData();
  }

  ngAfterViewInit() {
    this.paginator.pageSize = 45;
    this.checkRowsPerPage();
  }
  //event listener for searching
  @HostListener('document:keyup.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    }
  }
  //checking number of rows per page
  checkRowsPerPage() {
    if (this.paginator) {
      const rowsPerPage = this.paginator.pageSize;
      // console.log(`Number of rows per page:${rowsPerPage}`);
    }
  }

  openPolicy(policy: any) {
    this.openDetailTab.emit({ id: policy.id, label: policy.policyNumber + '-policy', type: 'policy' });
    // console.log(policy.id);
  }

  formatDate(date: string | undefined) {
    if (!date) return '';
    return date.substring(0, 10);
  }


  getMasterPolicy(Id: number) {
    // console.log('Inside getMasterPolicy')
    this.service.getMasterPolicy(Id).subscribe((res: IHome) => {
      // console.log('Inside getMasterPolicy Subscribe')
      this.policy = res;
      this.updateData = Object.assign({}, this.policy)

    })
  }

  getMasterPoliciesPremium(Id: number) {
    let policies = this.service.getMasterPoliciesPremium(Id).subscribe((res: Ipremiumtranscations[]) => {
      this.premiumtransaction = res;
      this.filteredData = this.premiumtransaction;
      this.totalItems = this.filteredData.length;
      // this.isLoading = false;
      this.applyPagination();
      //console.log(this.policies);
      res.sort((a,b)=>
      {
        const valueA = a.memberPolicyNumber.toLowerCase();
        const valueB = b.memberPolicyNumber.toLowerCase();
        if(isNaN(Number(valueA)) && isNaN(Number(valueB))){
          return valueA.localeCompare(valueB);
        }
        else if(!isNaN(Number(valueA)) && !isNaN(Number(valueB)))
     {
      return Number(valueA)-Number(valueB);
     }
     else{
      return isNaN(Number(valueA)) ? 1:-1;
     }
      });
      this.dataSource.data=res;
      this.dataSource.sort=this.sort;

    })
  }
  getAccData() {
    let insured = this.service.getDropdownAcc().subscribe((res: any[]) => {
      this.insured = res;
      // console.log(this.insured);
      this.dynamicTabService.sortDropdownData(this.insured, item => item.name);
    });
  }

  getDropPolTy() {
    let polTy = this.service.getDropdownPolT().subscribe((res: any[]) => {
      this.polTy = res;
      // console.log(this.polTy);
      this.dynamicTabService.sortDropdownData(this.polTy, item => item.name);
    })
  }
  getDropPolS() {
    let polS = this.service.getDropdownPolS().subscribe((res: any[]) => {
      this.polS = res;
      // console.log(this.polS);
      this.dynamicTabService.sortDropdownData(this.polS, item => item.name);
    })
  }
  getDropCon() {
    let Con = this.service.getDropdownCon().subscribe((res: any[]) => {
      this.Con = res;
      // console.log(this.Con);
      this.dynamicTabService.sortDropdownData(this.Con, item => item.name);
    })
  }

  //Policy update
  updatePolicy() {
    if (this.policy && this.policy.id && this.policy.id == this.dynamicTabService.selectedTabData.id) {
      if (sessionStorage.getItem('saveBtn') == 'true') {
        this.service.getaddOrUpdatePolicy(this.policy).subscribe({
          next: (res: IHome) => {
            // if (JSON.stringify(this.policy) == JSON.stringify(this.updateData)) }{
            this.response = res;
            this.isLoading = true;
            this.updateData = Object.assign({}, this.response);
            this.policy = this.response
            // const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTab);

        // if (currentTab) {
        //   currentTab.closable = true;
        //   const currentIndex = this.dynamicTabService.tabs.indexOf(currentTab)
        //   this.dynamicTabService.removeTab(currentTab);
        //   const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
        //   const nextTab = this.dynamicTabService.tabs[currentIndex];
        //   const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
        //   if (previousTab && actTab <= 0) {
        //     previousTab.isActive = true;
        //     this.body.openDetailTab(previousTab);
        //   }
        //   else if (nextTab && actTab <= 0) {
        //     nextTab.isActive = true;
        //     this.body.openDetailTab(nextTab);
        //   }
        //   else if (actTab == 0) {
        //     this.body.openDetailTab(actTab);
        //   }
        //   else {
        //     // If no previous tab, navigate to the default URL
        //     this.router.navigate(['/']);
        //   }
        // }
          },
          error: (err) => {
            this.notificationService.error("some error occured")
            // this.isLoading=false;
          }
        })
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
      }
      // else {
      //   this.dynamicTabService.closeTab(this.dynamicTabService.closableTab);
      // }
    }

  }

  closeTab() {
    if (sessionStorage.getItem("closeBtn") == "true" && this.policy && this.policy.id && this.policy.id == this.dynamicTabService.closableTab.id) {
      // this.dynamicTabService.closableTab.closable=false;
      if (JSON.stringify(this.policy) == JSON.stringify(this.updateData)) {
        const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTab);
        sessionStorage.setItem('closeBtn', 'false');
        if (currentTab) { 
          // currentTab.closable = true;
          const currentIndex = this.dynamicTabService.tabs.indexOf(currentTab)
          if(currentTab.closable==true)
          this.dynamicTabService.removeTab(currentTab);
          if(this.dynamicTabService.closableTab)
          this.dynamicTabService.removeTab(this.dynamicTabService.closableTab);
          const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
          const nextTab = this.dynamicTabService.tabs[currentIndex];
          const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
          if(this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTabData.label)){
            this.dynamicTabService.selectedTabData.isActive=true;
            this.body.openDetailTab(this.dynamicTabService.selectedTabData);
          }
          if (previousTab && actTab <= 0) {
            previousTab.isActive = true;
            this.body.openDetailTab(previousTab);

            // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
          }
          else if (nextTab && actTab <= 0) {
            nextTab.isActive = true;
            this.body.openDetailTab(nextTab);
          }
          else if (actTab == 0) {
            this.dynamicTabService.removeTab(currentTab);

          }
          // else {
          //   // If no previous tab, navigate to the default URL
          //   this.router.navigate(['/']);
          // }
        }
      }
      else {
        this.dynamicTabService.tabs.filter(tab => tab.isActive = false);
        if (this.dynamicTabService.tabs.filter(tab => tab.isActive != true))
          this.dynamicTabService.closableTab.isActive = true;
          this.body.openDetailTab(this.dynamicTabService.closableTab);
        this.dynamicTabService.selectedTabData = this.dynamicTabService.closableTab;
        const dialogRef = this.dialog.open(RefreshDialogComponent, {
          data: { message: 'closing?Closing' },
        });
        if (dialogRef.afterOpened())
          sessionStorage.setItem('closeBtn', 'false');
        const i = sessionStorage.getItem('closeBtn');
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'save') {
            sessionStorage.setItem('saveBtn', 'true');
            this.updatePolicy();
            this.body.forceCloseTab(this.dynamicTabService.closableTab);

          }
          else
            if (result === 'discard') {
             
              this.body.forceCloseTab(this.dynamicTabService.closableTab);
              sessionStorage.setItem('closeBtn', 'false')
          
            
            }
        });
      }
    }

  }

  loadTableData() {
    this.isLoading = true;
    this.getMasterPoliciesPremium(this.id);
  }
  refresh() {
    if (this.policy && this.policy.id && this.policy.id == this.dynamicTabService.selectedTabData.id) {
      if (sessionStorage.getItem('refreshBtn') == 'true') {
        if (JSON.stringify(this.policy) == JSON.stringify(this.updateData)) {
          this.isLoading = true;
          this.getAccData();
          this.getDropPolTy();
          this.getDropPolS();
          this.getDropCon();
          this.getMasterPoliciesPremium(this.id); //194745
          this.getMasterPolicy(this.id);
          this.cdRef.detectChanges();
          this.clearSearch();
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        }
        else {
          const dialogRef = this.dialog.open(RefreshDialogComponent, {
            data: { message: 'refreshing?Refreshing' },
          });
          if (dialogRef.afterOpened())
            sessionStorage.setItem('refreshBtn', 'false')

          dialogRef.afterClosed().subscribe(result => {
            if (result === 'save') {
              this.updatePolicy();
            }
            else if (result === 'discard') {
              this.getAccData();
              this.getDropPolTy();
              this.getDropPolS();
              this.getDropCon();
              this.getMasterPoliciesPremium(this.id); //194745
              this.getMasterPolicy(this.id);
              this.cdRef.detectChanges();
              sessionStorage.setItem('refreshBtn', 'false');
              // console.log("Main component refreshed");

            }

          });
        }
      }
    }

  }
  renewPolicy() {
    if (sessionStorage.getItem('renewBtn') == 'true' && this.policy.id == this.dynamicTabService.selectedTabData.id) {
      const dialogRenew = this.dialog.open(RenewPolicyComponent);
      if (dialogRenew.afterOpened())
        sessionStorage.setItem('renewBtn', 'false')
      dialogRenew.afterClosed().subscribe((result: boolean) => {

        if (this.policy.expirationDate === null || this.policy.expirationDate === undefined
          || this.policy.effectiveDate === null || this.policy.effectiveDate === undefined) {
          alert("ExpirationDate/Effective date is not selected");
        }
        else if (result === true) {
          this.service.renewPolicy(this.policy).subscribe((res: IHome) => {
            // this.policy=res;
            this.openPolicy(res);
            sessionStorage.setItem('renewBtn', 'false');
          });

        }

      })
    }

  }
  //delete
  deleteMasterPolicy(): void {
    if (sessionStorage.getItem('deleteBtn') == 'true' && this.policy && this.policy.id && this.policy.id == this.dynamicTabService.selectedTabData.id) {
      const dialogDel = this.dialog.open(DeleteDialogComponent);
      if (dialogDel.afterOpened())
        sessionStorage.setItem('deleteBtn', 'false')
      dialogDel.afterClosed().subscribe((result: boolean) => {
        if (result === true) {
          this.service.deletePolicy(this.policy.id).subscribe(res => {
            if (res) {
              this.policy = new IHome();
              console.log('Deleted successfully');
              // const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === 'Home'
              //   || tab.type === 'policy');
              const currentTab = this.dynamicTabService.tabs.find(tab => tab.label === this.dynamicTabService.selectedTab);

              if (currentTab) {
                currentTab.closable = true;
                const currentIndex = this.dynamicTabService.tabs.indexOf(currentTab)
                this.dynamicTabService.removeTab(currentTab);
                const previousTab = this.dynamicTabService.tabs[currentIndex - 1];
                const nextTab = this.dynamicTabService.tabs[currentIndex];
                const actTab: number = this.dynamicTabService.tabs.filter(t => t.isActive == true).length;
                if (previousTab && actTab <= 0) {
                  previousTab.isActive = true;
                  this.body.openDetailTab(previousTab);

                  // this.dynamicTabsService.tabs.forEach(tab => tab.isActive = true);
                }
                else if (nextTab && actTab <= 0) {
                  nextTab.isActive = true;
                  this.body.openDetailTab(nextTab);
                }
                else if (actTab == 0) {
                  this.body.openDetailTab(actTab);
                }
                else {
                  // If no previous tab, navigate to the default URL
                  this.router.navigate(['/']);
                }
              }

            }
            sessionStorage.setItem('deleteBtn', 'false');
          })
        }

      })
    }

  }
  openMemberPolicy(memberPolicyNumber: string) {
    const lh = window.location.hostname.toLowerCase();
    let env = ""
    var url = environment.outdoorNetUrl;
    window.open(`${environment.outdoorNetUrl}/search/?q=` + memberPolicyNumber, "_blank");
    // if (lh == 'localhost') {
    //   window.open(`http://${lh}:15472/search/?q=` + memberPolicyNumber, "_blank");
    // }
    // else if (lh.includes('dev')) {
    //   env = 'dev';
    //   window.open(`https://oui-ounet.allstar-dev.technology/search/?q=` + memberPolicyNumber, "_blank");
    // }
    // else if (lh.includes('dev')) {
    //   env = 'qa';
    //   window.open(`https://vm-22-oui-ue2-t:83/search/?q=` + memberPolicyNumber, "_blank");
    //   // window.open(`https://oui-ounet.allstar-qa.technology/search/?q=` + memberPolicyNumber, "_blank");
    // }
    // else {
    //   window.open(`https://vm-22-oui-ue2-t:83/search/?q=` + memberPolicyNumber, "_blank");
    // }
    // console.log('window.location.hostname : ' + window.location.hostname);
    // console.log('this.router.getCurrentNavigation : ' + this.router.getCurrentNavigation())
    // console.log('this.router.url : ' + this.router.url)

  }
  pageChanged(page: number): void {
    this.currentPage = page;
    this.filterData();
  }
  onPageChange(event: any): void {
    this.currentPageIndex = event.pageIndex;
    this.pageSize = 45;
    this.applyPagination();

  }
  filterData(): void {
    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredData = this.dataSource.data.slice(startIndex, endIndex);
  }

  clearSearch(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    this.searchTerm = '';
    this.isSearching = false;
    this.filteredData = this.premiumtransaction;
    this.applyPagination();
  }
  search(): void {
    if (this.premiumtransaction) {
      this.applyFilter();
    }

  }
  applyFilter(): void {
    this.pageSize = 45;
    this.currentPageIndex = 0;
    const searchValue = this.searchTerm.trim().toLowerCase();
    this.filteredData = this.premiumtransaction.filter((item) => {
      const searchFields = [item.name, item.memberPolicyNumber, item.transactionDate, item.transactionType,
      item.insuredValueChange, item.premiumChange];
      return searchFields.some((field) => String(field).toLowerCase().includes(searchValue));
    });
    this.totalItems = this.filteredData.length;
    this.isSearching = searchValue != '';
    this.applyPagination();
  }

  getTotalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  applyPagination(): void {

    const startIndex = this.currentPageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.dataSource.data = this.filteredData.slice(startIndex, endIndex);
  }
  sortData(column: keyof Ipremiumtranscations) {
    if (this.sortingColumn == column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    }
    else {
      this.sortingColumn = column;
      this.sortOrder = 'asc';
    }
    this.filteredData.sort((a, b) => {
      const valueA = (a[column] || '').toString();
      const valueB = (b[column] || '').toString();
      //compare mixed-case values
      if (valueA.toLowerCase() < valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? -1 : 1;
      }

      else if (valueA.toLowerCase() > valueB.toLowerCase()) {
        return this.sortOrder === 'asc' ? 1 : -1;
      }

      //Handle empty values
      if (valueA === '' && valueB === '') {
        return 0;
      } else if (valueA === '') {
        return -1;
      } else if (valueB === '') {
        return 1;
      }
      return 0;

    });
    this.applyPagination();
  }
}





